import { WeekScheduler } from './WeekScheduler';

import { SquarePen, UserX } from 'lucide-react';
import { useState } from 'react';

import { AddUnavailability } from './AddUnavailability';
import { Button } from '@/components/ui/button';
import styles from './style.module.css';

import data from '@/mock-data/week_scheduler_data.json';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE } from '@/routes';

export function ManageAvailability() {
  const [openUnavailability, setOpenUnavailability] = useState(false);
  const [showRepeatOption, setShowRepeatOption] = useState(false);
  const navigate = useNavigate();
  const { id: doctorId } = useParams();

  const fetchNextWeekContent = () => {
    return;
  };

  const fetchPreviousWeekContent = () => {};

  const handleUnavailability = () => {
    setShowRepeatOption(true);
    setOpenUnavailability(true);
  };

  const handleSlotClick = () => {
    setShowRepeatOption(false);
    setOpenUnavailability(true);
  };

  const handleEditAvailabilityClick = () => {
    navigate(
      `${ROUTE.DOCTOR_MANAGEMENT}/${doctorId}/${ROUTE.DOCTOR_MANAGE_SCHEDULE}`
    );
  };

  const handleSubmit = (formData: FormData) => {
    console.log('Form submitted:', formData);
  };

  return (
    <div
      style={{
        padding: '28px 24px',
        width: '100%',
        overflowX: 'auto',
        background: '#FFF',
      }}
    >
      <div className={styles['manage-availability-header-container']}>
        <p className={styles['manage-availability-heading']}>
          Current Availability
        </p>
        <div className="flex flex-row gap-2.5">
          <Button
            onClick={handleUnavailability}
            variant="secondary"
            className="flex items-center space-x-2 gap-2"
            data-testid="add-unavailability-button"
          >
            <UserX size={15} />
            Add Unavailability
          </Button>

          <Button
            onClick={handleEditAvailabilityClick}
            variant="secondary"
            className="flex items-center space-x-2 gap-2"
          >
            <SquarePen size={15} />
            Edit availability
          </Button>
        </div>
      </div>
      <WeekScheduler
        // @ts-expect-error@ts-ignore
        data={data}
        onLeftArrowClick={fetchPreviousWeekContent}
        onRightArrowClick={fetchNextWeekContent}
        onSlotClick={handleSlotClick}
      />

      <AddUnavailability
        open={openUnavailability}
        onOpenChange={setOpenUnavailability}
        onSubmit={handleSubmit}
        showRepeatOption={showRepeatOption}
      />
    </div>
  );
}
